<template>
  <div
    class="list-popup"
  >
    <div class="list-popup__dim" />
    <div class="list-popup__body">
      <div class="list-popup__head">
        LG Information Display Case Study : {{ subTitle }}
        
        <div class="list-popup__space" />
      </div>
      <div class="list-popup__content">
        <div class="list-popup__banner">
          <img
            :src="`/theme/rbFront/img/w/case-study/listBanner/${banner.image}`"
            alt=""
          >
          <a
            class="list-popup__banner-anchor"
            @click="handleClickBanner"
          >
            Learn More >
          </a>
        </div>
        <div class="list-popup__selectbox">
          <select
            v-model="currentRegin"
            class="list-popup__select"
          >
            <template v-for="option in items">
              <option
                v-if="filterRegionList(option)"
                :key="option.code"
                :value="option.code"
                class="list-popup__select-item"
              >
                {{ option.name }}
              </option>
            </template>
          </select>
        </div>
        <ul class="list-popup__list">
          <template v-for="item in currentItems">
            <li
              v-if="filterItem(item)"
              :key="item.id"
              class="list-popup__list-item"
            >
              <div class="list-popup__thumbnail">
                <a
                  class="list-popup__thumbnail-anchor"
                  @click="$emit('click:video', item)"
                >
                  <img
                    :src="`${imagesHost}${item.thumbnailImage}`"
                    class="list-popup__thumbnail-image"
                    alt=""
                  >
                  <img
                    src="~@/assets/img/icon_video.png"
                    class="list-popup__thumbnail-icon-video"
                    alt=""
                  >
                  <span class="list-popup__vertical-icon">
                    <img
                      v-if="item.vertical === 'Corporate'"
                      src="~@/assets/img/icon_corporate.png"
                      alt=""
                      class="list-popup__vertical-icon-image"
                    >
                    <img
                      v-if="item.vertical === 'Education'"
                      src="~@/assets/img/icon_education.png"
                      alt=""
                      class="list-popup__vertical-icon-image"
                    >
                    <img
                      v-if="item.vertical === 'General'"
                      src="~@/assets/img/icon_general.png"
                      alt=""
                      class="list-popup__vertical-icon-image"
                    >
                    <img
                      v-if="item.vertical === 'Government'"
                      src="~@/assets/img/icon_government.png"
                      alt=""
                      class="list-popup__vertical-icon-image"
                    >
                    <img
                      v-if="item.vertical === 'Hospitality'"
                      src="~@/assets/img/icon_hospitality.png"
                      alt=""
                      class="list-popup__vertical-icon-image"
                    >
                    <img
                      v-if="item.vertical === 'Public Space'"
                      src="~@/assets/img/icon_public-space.png"
                      alt=""
                      class="list-popup__vertical-icon-image"
                    >
                    <img
                      v-if="item.vertical === 'Retail'"
                      src="~@/assets/img/icon_retail.png"
                      alt=""
                      class="list-popup__vertical-icon-image"
                    >
                    <img
                      v-if="item.vertical === 'Transportation'"
                      src="~@/assets/img/icon_transportation.png"
                      alt=""
                      class="list-popup__vertical-icon-image"
                    >
                  </span>
                </a>
              </div>
              <div class="list-popup__list-content">
                <div class="list-popup__vertical">
                  {{ item.vertical }}
                </div>
                <div class="list-popup__title">
                  <a
                    class="list-popup__title-anchor"
                    @click="handleClickDetailLink(item.detailLink, item.title)"
                  >{{ item.title }}</a>
                </div>
                <template v-if="item.recommendedProduct.length">
                  <div class="list-popup__subtitle">
                    Recommended Products
                  </div>
                  <div class="list-popup__recommended">
                    <carousel
                      :per-page="4"
                      :mouse-drag="true"
                      :navigation-enabled="true"
                      :pagination-enabled="false"
                      class="list-popup__recommended-list"
                    >
                      <slide
                        v-for="(product, index) in item.recommendedProduct.filter(p => p.isActive === 'ACTIVE')"
                        :key="`popup__recommended-${index}`"
                        class="list-popup__recommended-item"
                      >
                        <a
                          class="list-popup__recommended-anchor"
                          @click="handleClickProductDetailLink(product.detailLink, product.prodThumb, product.modelName, product.productCategory1, product.productCategory2, product.productCategory3)"
                        >
                          <img
                            :src="`${imagesHost}${product.prodThumb}`"
                            class="list-popup__recommended-thumbnail"
                          >
                          <div class="list-popup__recommended-product">{{ product.modelSeries }}</div>
                          <div class="list-popup__recommended-modelname">{{ product.modelName }}</div>
                        </a>
                      </slide>
                    </carousel>
                  </div>
                </template>
                <div class="list-popup__software">
                  <a
                    v-if="item.solutionTitle1"
                    :href="item.solutionLink1"
                    class="list-popup__software-anchor"
                    target="_blank"
                  >
                    {{ item.solutionTitle1 }}
                    <span><img
                      src="/theme/rbFront/img/w/case-study/mobile/arrow_right.png"
                      alt=""
                    ></span>
                  </a>
                  <a
                    v-if="item.solutionTitle2"
                    :href="item.solutionLink2"
                    class="list-popup__software-anchor"
                    target="_blank"
                  >
                    {{ item.solutionTitle2 }}
                    <span><img
                      src="/theme/rbFront/img/w/case-study/mobile/arrow_right.png"
                      alt=""
                    ></span>
                  </a>
                </div>
              </div>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <button
      class="list-popup__close-button"
      @click="$emit('click:close')"
    >
      <img
        src="~@/assets/img/button_close2.png"
        class="list-popup__close-button-image"
        alt=""
      >
    </button>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
  name: 'ListPopup',
  components: {
    Carousel,
    Slide
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    region: {
      type: String,
      required: true,
    },
    regionName: {
      type: String,
      required: false,
      default: ''
    },
    viewMode: {
      type: String,
      required: true,
    },
    vertical: {
      type: Object,
      required: true,
    },
    productCategory: {
      type: Object,
      required: true,
    },
    ga4Text: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentRegin: '',
      currentItems: []
    }
  },
  computed: {
    imagesHost() {
      if (window.location.host.indexOf('www.') > -1) {
        return 'https://image.lgcommercialdisplay.com'
      } else {
        return 'https://stg.lgcommercialdisplay.com'
      }
    },
    subTitle() {
      if (this.viewMode === 'region' || this.viewMode === 'product') {
        let tempText = ''
        this.items.forEach(region => {
          if (region.code === this.currentRegin) {
            tempText = region.name
          }
        })
        return tempText
      } else {
        return this.vertical.name
      }
    },
    banner() {
      if (this.viewMode === 'region' || this.viewMode === 'product') {
        return {
          image: 'Virtual-showroom-tour-experience-virtual-showroom-tour.jpg',
          link: '/dc/vertical_category/',
        }
      } else {
        return {
          image: this.vertical.listBanner,
          link: this.vertical.url,
        }
      }
    }
  },
  watch: {
    region: {
      immediate: true,
      handler(value) {
        this.currentRegin = value
      }
    },
    currentRegin: {
      immediate: true,
      handler() {
        this.items.forEach((item) => {
          if (item.code === this.currentRegin) {
            this.currentItems = item.items
          }
        })
      }
    },
  }, 
  methods: {
    filterItem(item) {
      if (this.viewMode === 'region' || (this.viewMode === 'vertical' && item.vertical === this.vertical.name)) {
        return true
      } else if(this.viewMode === 'product') {
        let hasProductCategoryCount = 0
        item.recommendedProduct.forEach(prd => {
          if (prd.productCategory1 === this.productCategory.name) {
            hasProductCategoryCount++;
          }
        })
        return hasProductCategoryCount ? true : false
      } else {
        return false
      }
    },
    filterRegionList(region) {
      if (this.viewMode === 'vertical') {
        let hasVerticalCount = 0
        region.items.forEach((item) => {
          if (item.vertical === this.vertical.name) {
            hasVerticalCount++
          }
        })
        return hasVerticalCount ? true : false
      } else if(this.viewMode === 'product') {
        let hasProductCategoryCount = 0
        region.items.forEach(item => {
          item.recommendedProduct.forEach(prd => {
            if (prd.productCategory1 === this.productCategory.name) {
              hasProductCategoryCount++;
            }
          })
        })
        return hasProductCategoryCount ? true : false
      } else {
        return true
      }
    },
    handleClickDetailLink(url, text) {
      window.dataLayer.push({
        event: 'select_story',
        click_text: text, 
        click_url: url
      });
      window.open(url, '_blank')
    },
    handleClickProductDetailLink(url, img, name, category1, category2, category3) {
      window.dataLayer.push({
        event: 'select_product',
        click_text: 'View Detail',
        click_url: url,
        img_url: img,
        img_alt: '',
        product_name: name,
        product_category1: category1,
        product_category2: category2,
        product_category3: category3
      });
      window.open(url, '_blank')
    },
    handleClickBanner() {
      window.dataLayer.push({
        event: 'showroom_entrance',
        click_text: this.ga4Text,
        click_url: this.banner.link
      });
      window.open(this.banner.link, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
$list-popup: '.list-popup';
#{$list-popup} {
  width: 972px;
  min-height: 700px;
  position: fixed;
  min-width: 350px;
  max-height: 700px;
  box-sizing: border-box;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;

  &__dim {
    position: fixed;
    background-color: #000;
    opacity: 0.4;
    width: 300%;
    height: 300%;
    left: -100%;
    top: -100%;
    z-index: 0;
  }
  &__body {
    position: relative;
    z-index: 1;
    background-color: #fff;
    height: 100%;
  }
  &__head {
    position: relative;
    padding: 40px 40px 40px 33px;
    height: 18px;
    font-size: 24px;
    line-height: 36px;
    font-weight: 400;
    margin-bottom: 20px;
  }
  &__space {
    height: 1px;
    margin-top: 40px;
    background-color: #fff;
    border-bottom: 1px solid #bfbfbf;
    position: relative;
    z-index: 100;
  }
  &__banner {
    position: relative;
    // top: 23px;
  }
  &__banner-anchor {
    position: absolute;
    width: 200px;
    height: 50px;
    border-radius: 25px;
    line-height: 50px;
    font-size: 18px;
    background-color: #fd312e;
    color: #fff;
    text-align: center;
    right: 40px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
  &__content {
    box-sizing: border-box;
    min-height: 360px;
    max-height: 608px;
    overflow-y: auto;
    padding: 20px 35px 0;
  }
  &__selectbox {
    padding: 10px 0 14px;
  }
  &__select {
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    font-size: 18px;
    line-height: 1.5;
    color: #444;
    background-color: #fff;
    padding: 8px 44px 8px 10px;
    margin: 0;
    border: 1px solid #aaa;
    border-radius: 4px;
    box-sizing: border-box;
    background: url(~@/assets/img/arrow_down.png) 104% 18px no-repeat;
  }
  &__list-item {
    display: flex;
    justify-content: space-between;
    // height: 184px;
    padding: 35px 0 32px;
    border-bottom: solid 2px #bfbfbf;
  }
  &__list-item:first-child {
    padding-top: 0;
  }
  &__list-item:last-child {
    border-bottom: 0;
  }
  &__thumbnail {
    position: relative;
    width: 328px;
  }
  &__thumbnail-anchor {
    display: block;
    position: relative;
    width: 100%;
  }
  &__thumbnail-anchor:hover {
    cursor: pointer;
  }
  &__thumbnail-image {
    width: 100%;
  }
  &__thumbnail-icon-video {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  &__vertical-icon {
    display: block;
    width: 54px;
    height: 50px;
    position: absolute;
    right: 0;
    bottom: -2px;
    background-color: #fff;
  }
  &__vertical-icon-image {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    height: 100%;
  }
  &__list-content {
    width: 504px;
    box-sizing: border-box;
    padding-right: 3px;
  }
  &__vertical {
    font-size: 14px;
    line-height: 14px;
    color: #221d1d;
    margin-bottom: 8px;
  }
  &__title {
    font-size: 20px;
    line-height: 22px;
    color: #221d1d;
    margin-bottom: 20px;
    font-weight: 400;
  }
  &__title-anchor {
    display: -webkit-box;
    word-wrap: break-word;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    font-weight: 400;
    color: #fd312e;
    cursor: pointer;
  }
  &__subtitle {
    font-size: 14px;
    line-height: 14px;
    color: #221d1d;
    margin-bottom: 4px;
  }
  &__close-button {
    position: absolute;
    top: 40px;
    right: 23px;
    width: 26px;
    height: 26px;
    z-index: 1;
  }
  &__recommended-item {
    flex-basis: 93px;
    height: 112px;
    box-sizing: border-box;
    padding: 8px 8px 15px;
    border-radius: 4px;
    margin-left: 12px;
    border: solid 1px #2d2d2d;
    text-align: center;
  }
  &__recommended-item:first-child{
    margin-left: 0;
  }
  &__recommended-thumbnail {
    max-width: 90px;
    height: 50px;
  }
  &__recommended-product {
    font-size: 11px;
    line-height: 11px;
    color: #221815;
    margin-bottom: 6px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
    width: 93px;
  }
  &__recommended-anchor {
    cursor: pointer;
  }
  &__recommended-modelname {
    font-size: 18px;
    line-height: 18px;
    color: #221815;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
    width: 93px;
  }
  &__software {
    margin-top: 10px;
    font-size: 20px;
  }
  &__software-anchor {
    position: relative;
    display: block;
    height: 38px;
    line-height: 38px;
    border: solid 1px #000;
    border-radius: 3px;
    padding: 0 18px;
    margin-top: 8px;

    span {
      position: absolute;
      display: block;
      width: 18px;
      top: 50%;
      right: 12px;
      transform: translateY(-50%);
      img {
        max-width: 100%;
      }
    }
  }
  /deep/ .VueCarousel-navigation-prev {
    padding: 0!important;
    margin: 0!important;
    width: 15px;
    height: 25px;
    top: 38px;
    left: -25px;
    transform: translateY(0%);
    text-indent: -9999px;
    background: url(~@/assets/img/icon_prevafter15x25.png) 0 0 no-repeat;
  }
  /deep/ .VueCarousel-navigation-next {
    padding: 0!important;
    margin: 0!important;
    width: 15px;
    height: 25px;
    top: 38px;
    right: -25px;
    transform: translateY(0%);
    text-indent: -9999px;
    background: url(~@/assets/img/icon_prevafter15x25.png) 0 100% no-repeat;
  }
}


</style>
